  <div class="rounded-2xl h-full flex flex-col border border-gray-200 bg-white px-2 py-2">
    <ion-content [scrollX]="true" style="--background: white">
      @if (!loading()) {
        <ion-refresher
          slot="fixed"
          (ionRefresh)="refreshHandler($event)"
          pullFactor="0.3"
        >
          <ion-refresher-content refreshingSpinner="bubbles"></ion-refresher-content>
        </ion-refresher>
      }
      @if(loading()) {
        <table class="w-full table-fixed border-separate border-spacing-0">

          <thead class="relative z-60">
            <tr #headRowEl class="border-b border-gray-200">
              @for (col of columns; track $index) {
                <th class="h-11 px-3 py-1 text-left sticky top-0 z-60 bg-white">
                  <div class="flex items-center h-full text-gray-500 font-title font-medium text-theme-xs">
                    <div class="h-6 w-17 animate-pulse bg-gray-300 rounded-xl"></div>
                  </div>
                </th>
              }
            </tr>
          </thead>

          <tbody>
            @for (_ of [].constructor(10); let last = $last; track $index) {

              <tr class="h-8"
                  [style.top.px]="headerTopPx">
                <td
                  [attr.colspan]="columns.length"
                  class="px-2 font-title font-medium text-theme-xs text-gray-700 bg-gray-100 border-b border-brand-500"
              >
                  <div class="h-4 w-25 animate-pulse bg-gray-300 rounded-xl"></div>
                </td>
              </tr>

              <tr class="h-8"
                  [style.top.px]="headerTopPx + dayRowHeightPx">
                <td
                  [attr.colspan]="columns.length"
                  class="px-2 font-title font-medium text-theme-xs text-gray-700 bg-brand-25 relative"
                  >
                  <div class="h-4 w-20 animate-pulse bg-gray-300 rounded-xl"></div>
                </td>
              </tr>

              <tr class="hover:bg-gray-50 h-12">
                @for (col of columns; let ci = $index; track ci) {
                  <td class="px-2 font-title font-medium text-theme-xs text-gray-700 h-12"
                    [class.border-b]="!last"
                    [class.border-gray-200]="!last"
                  >
                    <div class="h-4 w-15 animate-pulse bg-gray-300 rounded-xl"></div>
                  </td>
                }
              </tr>
            }
          </tbody>

        </table>
      }@else if(!loading() && data.length > 0){
        <!-- <div class="overflow-x-scroll"> -->
          <table class="w-full min-w-[300px] table-fixed border-separate border-spacing-0">
  
            <thead class="relative z-60">
              <tr #headRowEl class="border-b border-gray-200">
                @for (col of columns; track $index; let first = $first; let last = $last) {
                  <th class="h-11 px-3 py-1 text-left sticky top-0 z-60 bg-gray-50"
                    [class.rounded-tl-xl]="first"
                    [class.rounded-tr-xl]="last"
                  >
                    <div class="flex items-center h-full text-gray-500 font-title font-medium text-theme-xs">
                      <span class="">
                        {{ col.title }}
                      </span>
                    </div>
                  </th>
                }
              </tr>
            </thead>
  
            <tbody>
              @for (group of data; let ri = $index, last = $last; track group) {
  
                @if (group.isNewDay) {
                  <tr class="h-8 sticky z-50"
                      [style.top.px]="headerTopPx">
                    <td
                      [attr.colspan]="columns.length"
                      class="px-2 font-title text-theme-xs text-gray-700 bg-gray-100 border-b border-brand-500"
                  >
                      {{ group.from | date: 'mediumDate':'UTC' }}
                    </td>
                  </tr>
                }
  
                @if (group.isNewHourRange) {
                <tr class="h-8 sticky z-40"
                    [style.top.px]="headerTopPx + dayRowHeightPx">
                  <td
                    [attr.colspan]="columns.length"
                    class="px-2 font-title text-theme-xs text-gray-700 bg-brand-25 relative"
                    >
                    {{ group.from | hourRangePipe }}
                  </td>
                </tr>
                }
  
                <tr class="hover:bg-gray-50 h-12">
                  @for (col of columns; let ci = $index; track ci) {
                    <td class="px-2 font-title text-theme-sm text-gray-700 h-12"
                      [class.border-b]="!last"
                      [class.border-gray-200]="!last"
                      [class]="col.cssClasses"
                    >
                      @if (ci === 0) { {{ group.from | date: datePipeFormat():"UTC"}} }
                      @else if (ci === 1) { {{ group.to | date: datePipeFormat():"UTC"}} }
                      @else { {{ group[col.key] }} }
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        <!-- </div> -->
      }
      @if(!disableInfiniteScroll()  && !loading()){
        <ion-infinite-scroll
          (ionInfinite)="infiniteScrollHandler($event)"
        >
          <ion-infinite-scroll-content loadingSpinner="bubbles"></ion-infinite-scroll-content>
        </ion-infinite-scroll>
      }
    </ion-content>
  </div>